var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerpdf"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/images/logos/viessmann_wordmark_rgb_1_vitorange.png")}}),_c('div',[_vm._v("Plan d'Action Commercial 2026 - Page "+_vm._s(_vm.page))])])
}
var staticRenderFns = []

export { render, staticRenderFns }